<template>
  <Transition name="modal-fade">
    <div
      v-if="show"
      class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/40 dark:bg-brand-900/60 backdrop-blur-xl"
      @click.self="closeModal"
    >
      <div class="w-full max-w-3xl rounded-[28px] border bg-white dark:bg-brand-800 border-slate-100 dark:border-brand-700/50 shadow-2xl p-8 sm:p-12">
        
        <div class="text-center mb-8">
          <img src="@/assets/1.png" alt="ControlEase" class="h-14 mx-auto mb-6"/>
          <h1 class="text-3xl font-bold tracking-tight text-slate-900 dark:text-white"><span class="bg-gradient-to-r from-brand-500 to-fuchsia-500 dark:from-purple-400 dark:to-violet-300 bg-clip-text text-transparent">Endereço</span></h1>
          <p class="text-sm text-slate-600 dark:text-slate-400 mt-2">Passo 2 de 2</p>
        </div>

        <div v-if="feedbackMessage.text" :class="['mb-6 flex items-center gap-2 rounded-xl px-4 py-3 text-sm font-medium border',
          feedbackMessage.type === 'success'
            ? 'bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-500/10 dark:text-emerald-300 dark:border-emerald-400/30'
            : 'bg-rose-50 text-rose-700 border-rose-200 dark:bg-rose-500/10 dark:text-rose-300 dark:border-rose-400/30']">
          <span class="material-symbols-outlined text-xl">{{ feedbackMessage.type === 'success' ? 'check_circle' : 'error' }}</span>
          <span class="truncate">{{ feedbackMessage.text }}</span>
        </div>

        <form @submit.prevent="submitAddress" class="space-y-6" novalidate>
          <div class="grid grid-cols-3 gap-4">
            <div class="col-span-1">
              <label for="cep" class="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-2">CEP</label>
              <input id="cep" v-model="form.cep" @input="fetchAddressByCep" type="text" placeholder="Apenas números" required maxlength="8" class="w-full rounded-2xl border bg-slate-50/70 dark:bg-brand-900/40 border-slate-200 dark:border-brand-700/50 px-4 py-3 text-sm text-slate-900 dark:text-white placeholder:text-slate-400 dark:placeholder:text-slate-500 outline-none transition focus:ring-4 focus:ring-brand-500/20 focus:border-brand-500"/>
            </div>
            <div class="col-span-2">
              <label for="logradouro" class="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-2">Logradouro</label>
              <input id="logradouro" v-model="form.logradouro" type="text" required class="w-full rounded-2xl border bg-slate-50/70 dark:bg-brand-900/40 border-slate-200 dark:border-brand-700/50 px-4 py-3 text-sm text-slate-900 dark:text-white placeholder:text-slate-400 dark:placeholder:text-slate-500 outline-none transition focus:ring-4 focus:ring-brand-500/20 focus:border-brand-500"/>
            </div>
          </div>

          <div class="grid grid-cols-3 gap-4">
            <div class="col-span-1">
              <label for="numero" class="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-2">Número</label>
              <input id="numero" v-model="form.numero" type="text" required class="w-full rounded-2xl border bg-slate-50/70 dark:bg-brand-900/40 border-slate-200 dark:border-brand-700/50 px-4 py-3 text-sm text-slate-900 dark:text-white placeholder:text-slate-400 dark:placeholder:text-slate-500 outline-none transition focus:ring-4 focus:ring-brand-500/20 focus:border-brand-500"/>
            </div>
            <div class="col-span-2">
              <label for="bairro" class="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-2">Bairro</label>
              <input id="bairro" v-model="form.bairro" type="text" required class="w-full rounded-2xl border bg-slate-50/70 dark:bg-brand-900/40 border-slate-200 dark:border-brand-700/50 px-4 py-3 text-sm text-slate-900 dark:text-white placeholder:text-slate-400 dark:placeholder:text-slate-500 outline-none transition focus:ring-4 focus:ring-brand-500/20 focus:border-brand-500"/>
            </div>
          </div>

          <div class="grid grid-cols-2 gap-4">
            <div>
              <label for="localidade" class="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-2">Cidade</label>
              <input id="localidade" v-model="form.localidade" type="text" required class="w-full rounded-2xl border bg-slate-50/70 dark:bg-brand-900/40 border-slate-200 dark:border-brand-700/50 px-4 py-3 text-sm text-slate-900 dark:text-white placeholder:text-slate-400 dark:placeholder:text-slate-500 outline-none transition focus:ring-4 focus:ring-brand-500/20 focus:border-brand-500"/>
            </div>
            <div>
              <label for="uf" class="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-2">Estado</label>
              <input id="uf" v-model="form.uf" type="text" maxlength="2" required class="w-full uppercase tracking-wide rounded-2xl border bg-slate-50/70 dark:bg-brand-900/40 border-slate-200 dark:border-brand-700/50 px-4 py-3 text-sm text-slate-900 dark:text-white placeholder:text-slate-400 dark:placeholder:text-slate-500 outline-none transition focus:ring-4 focus:ring-brand-500/20 focus:border-brand-500"/>
            </div>
          </div>

          <div>
            <label for="complemento" class="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-2">Complemento</label>
            <input id="complemento" v-model="form.complemento" type="text" class="w-full rounded-2xl border bg-slate-50/70 dark:bg-brand-900/40 border-slate-200 dark:border-brand-700/50 px-4 py-3 text-sm text-slate-900 dark:text-white placeholder:text-slate-400 dark:placeholder:text-slate-500 outline-none transition focus:ring-4 focus:ring-brand-500/20 focus:border-brand-500"/>
          </div>

          <button type="submit" :disabled="isLoading" class="group relative w-full rounded-2xl bg-gradient-to-r from-violet-600 via-fuchsia-600 to-indigo-600 px-5 py-3.5 text-sm font-semibold text-white shadow-[0_12px_40px_-8px_rgba(124,58,237,.55)] transition active:scale-[.99] disabled:opacity-70">
            <span v-if="isLoading" class="loader-modern mr-2 align-middle"></span>
            <span class="relative z-10">{{ isLoading ? 'Finalizando…' : 'Finalizar cadastro' }}</span>
            <span class="pointer-events-none absolute inset-0 rounded-2xl ring-1 ring-white/10"></span>
          </button>
        </form>
      </div>
    </div>
  </Transition>
</template>

<script setup>
import { ref, reactive, watch } from 'vue'
import userService from '@/service/userService'
import axios from 'axios'

const props = defineProps({
  show: {
    type: Boolean,
    default: false
  },
  userId: {
    type: [String, Number],
    default: null
  }
})

const emit = defineEmits(['close', 'registration-complete', 'switch-view'])

const closeModal = () => {
  emit('close')
}

const localUserId = ref(null)
const isLoading = ref(false)
const feedbackMessage = ref({ text: '', type: '' })
const form = reactive({ cep: '', logradouro: '', complemento: '', bairro: '', localidade: '', uf: '', numero: '' })
let cepDebounceTimer = null

const resetForm = () => {
  Object.assign(form, { cep: '', logradouro: '', complemento: '', bairro: '', localidade: '', uf: '', numero: '' })
  feedbackMessage.value = { text: '', type: '' }
  isLoading.value = false
  clearTimeout(cepDebounceTimer)
}

watch(() => props.show, (newVal) => {
  if (newVal) {
    resetForm()
    localUserId.value = props.userId
    if (!localUserId.value) { 
      feedbackMessage.value = { text: 'ID de usuário não encontrado.', type: 'error' }
      setTimeout(() => emit('switch-view', 'register'), 1500)
    }
  }
})

const fetchAddressByCep = () => {
  clearTimeout(cepDebounceTimer)
  const cep = form.cep.replace(/\D/g, '')
  if (cep.length === 8) {
    cepDebounceTimer = setTimeout(async () => {
      try {
        const { data } = await axios.get(`https://viacep.com.br/ws/${cep}/json/`)
        if (!data.erro) { 
          form.logradouro = data.logradouro; 
          form.bairro = data.bairro; 
          form.localidade = data.localidade; 
          form.uf = data.uf 
        }
        else { feedbackMessage.value = { text: 'CEP não encontrado.', type: 'error' } }
      } catch { feedbackMessage.value = { text: 'Erro ao buscar CEP.', type: 'error' } }
    }, 300)
  }
}

const submitAddress = async () => {
  if (!localUserId.value) {
    feedbackMessage.value = { text: 'Erro: ID de usuário perdido. Tente novamente.', type: 'error' }
    return
  }
  isLoading.value = true
  feedbackMessage.value = { text: '', type: '' }
  try {
    await userService.updateUser(localUserId.value, { endereco: form })
    feedbackMessage.value = { text: 'Cadastro finalizado! Redirecionando…', type: 'success' }
    setTimeout(() => {
      emit('registration-complete')
      resetForm()
    }, 1200)
  } catch { 
    feedbackMessage.value = { text: 'Não foi possível salvar o endereço.', type: 'error' } 
  }
  finally { isLoading.value = false }
}
</script>

<style scoped>
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease;
}
.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}
.loader-modern{width:18px;height:18px;border:2px solid transparent;border-top-color:#fff;border-right-color:#fff;border-radius:50%;display:inline-block;animation:spin .7s linear infinite}
@keyframes spin{to{transform:rotate(360deg)}}
</style>